// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('/push-sw.js')
//       .then(reg => console.log('✅ Service Worker registered:', reg))
//       .catch(err =>
//         console.error('❌ Service Worker registration failed:', err)
//       );
//   });
// }

// Disable service worker for debugging
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
// }
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));

 // "src/manifest.webmanifest",
   // "src/push-sw.js"
              // "serviceWorker": "src/ngsw-config.json",
